//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dayjs from 'dayjs';
import { mapActions, mapGetters } from 'vuex';
import messageBox from '@/components/messageBox';
import { getPipelineList } from '@/graphql/api/build.js';
import createDialog from './create';
import detailDrawer from './detail';
import { CosMixin } from '@/mixins/cos';
import { GetKvlist, UpdateKvByKey } from '@/api/kv.js';
import { listCustomBranches } from '@/graphql/api/gitBranch';
import { formatGqlString, whereGql } from '@/graphql/util';

const MP_ROBOT_OPTIONS = [
  '23',
  '13',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
];

export default {
  components: {
    messageBox,
    createDialog,
    detailDrawer,
  },
  mixins: [CosMixin],
  data() {
    return {
      tab: 'mp',
      loading: false,
      search: {
        page: 1,
        page_size: 10,
      },
      total: 0,
      list: [],
      editJson: '',
      editId: '',
      showCreate: false,
      showDetail: false,
      detailData: {},
      buildStatus: {
        pending: '构建中',
        success: '构建成功',
        failed: '构建失败',
        stopped: '已停止',
      },
      stoppingIds: [],
      apiUrl: {
        h5: '/api/access/pb/cmd/BuildServer/BuildService/BuildCustomH5',
        web: '/api/access/pb/cmd/BuildServer/BuildService/BuildCustomWeb',
        mp: '/api/access/pb/cmd/BuildServer/BuildService/BuildMp',
        stop: '/api/access/pb/cmd/BuildServer/BuildService/StopBuild',
      },
      refreshTimer: null, // 定时刷新定时器
      env: process.env.NODE_ENV,
      kvConfig: {},
      kvFullConfig: {},
      kvInfo: {},
      showBuildConfig: false,
      buildConfigSaving: false,
      buildConfigForm: {
        BASE_PACKAGE_BRANCH: '',
        CUSTOM_BRANCH: '',
        THIRD_DIST_PACKAGES: [],
      },
      configBuildBranchOptions: [],
      configBuildBranchLoading: false,
      robotOptions: MP_ROBOT_OPTIONS,
    };
  },
  computed: {
    ...mapGetters('user'),
    isProduction() {
      return this.tab === 'mp' && this.env === 'production';
    },
    currentBuildConfig() {
      return this.kvFullConfig?.[this.tab] || {};
    },
    buildConfigTitle() {
      const labelMap = {
        h5: 'H5',
        web: 'Web',
        mp: '小程序',
      };
      return `${labelMap[this.tab] || ''}构建配置`;
    },
  },
  async created() {
    await this.getKvConfig();
    this.getList();
  },
  beforeDestroy() {
    // 组件销毁时清除定时器，防止内存泄漏
    this.clearRefreshTimer();
  },
  mounted() {},
  methods: {
    ...mapActions('user'),
    clearRefreshTimer() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
        this.refreshTimer = null;
      }
    },
    hasPendingItem() {
      return this.list.some((item) => item.status === 'pending');
    },
    handleRefreshTimer() {
      const hasPending = this.hasPendingItem();
      if (hasPending) {
        if (!this.refreshTimer) {
          this.refreshTimer = setInterval(() => {
            this.getList(false);
          }, 20000);
        }
      } else {
        this.clearRefreshTimer();
      }
    },
    async getList(init = true) {
      if (init) this.loading = true;
      try {
        const res = await getPipelineList(
          {
            platform: this.tab,
            limit: this.search.page_size,
            offset: this.search.page_size * (this.search.page - 1),
          },
          {
            showLoading: init,
          },
        );
        this.list = res?.front_end_build_log?._data || [];
        this.total = res?.front_end_build_log?._aggregate.count;
      } catch (err) {
        console.log(err);
      } finally {
        if (init) this.loading = false;
        this.handleRefreshTimer();
      }
    },
    handleSizeChange(value) {
      this.search.page_size = value;
      this.search.page = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.search.page = val;
      this.getList();
    },
    async stopPipeline(row) {
      if (!row?.id) return;
      try {
        await this.$confirm(`确认停止构建 ${row.id} 吗？`, '停止构建', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
      } catch (error) {
        return;
      }
      if (!this.stoppingIds.includes(row.id)) {
        this.stoppingIds.push(row.id);
      }
      try {
        await this.$request({
          url: this.apiUrl.stop,
          data: {
            id: row.id,
            reason: '用户手动停止构建',
          },
        });
        this.$message.success('停止命令已发送');
        await this.getList(false);
      } catch (error) {
        console.error('stopPipeline error', error);
        this.$message.error('停止命令发送失败');
      } finally {
        this.stoppingIds = this.stoppingIds.filter((id) => id !== row.id);
      }
    },
    publish(data) {
      this.$request({
        url: this.apiUrl[this.tab],
        data,
      }).then(() => {
        this.showCreate = false;
        this.$message.success('执行成功');
        this.getList();
      });
    },
    formatTime(time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
    },
    async handleTabChange() {
      this.clearRefreshTimer();
      await this.getKvConfig();
      this.getList();
    },
    openDetail(data) {
      this.detailData = data;
      this.showDetail = true;
    },
    calculateBuildDuration(start, end) {
      const totalSeconds = Math.abs(end - start);
      const hours = Math.floor(totalSeconds / 3600);
      const remainingSecondsAfterHours = totalSeconds % 3600;
      const minutes = Math.floor(remainingSecondsAfterHours / 60);
      const seconds = remainingSecondsAfterHours % 60;
      const parts = [];
      if (hours > 0) {
        parts.push(`${hours}小时`);
      }
      if (minutes > 0) {
        parts.push(`${minutes}分钟`);
      }
      if (parts.length === 0 || seconds > 0) {
        parts.push(`${seconds}秒`);
      }
      return parts.join('');
    },
    downloadUrlHttp(url, filename) {
      const x = new window.XMLHttpRequest();
      x.open('GET', url, true);
      x.responseType = 'blob';
      x.onload = () => {
        const url = window.URL.createObjectURL(x.response);
        if (window.downLink) window.downLink = null;
        window.downLink = document.createElement('a');
        window.downLink.href = url;
        window.downLink.style.display = 'none';
        window.downLink.download = filename;
        window.downLink.click();
      };
      x.send();
    },
    async download(url, name) {
      const publicUrl = await this.getPrivateUrl(url);
      this.downloadUrlHttp(publicUrl, name);
    },
    async getKvConfig() {
      try {
        const res = await GetKvlist({
          limit: 1,
          offset: 0,
          tableName: 'kv',
          filter: whereGql([
            {
              whereGqlType: 'is',
              key: `front_end_build_config`,
            },
          ]),
        });
        const kv = res?.kv._data?.[0] || {};
        const config = JSON.parse(kv?.value || '{}');
        this.kvInfo = kv;
        this.kvFullConfig = config;
        this.kvConfig = config?.[this.tab] || {};
      } catch (error) {
        console.error('getKvConfig error', error);
      }
    },
    async openBuildConfig() {
      const config = this.currentBuildConfig;
      this.buildConfigForm = {
        BASE_PACKAGE_BRANCH: config.BASE_PACKAGE_BRANCH || '',
        CUSTOM_BRANCH: config.CUSTOM_BRANCH || '',
        THIRD_DIST_PACKAGES: this.normalizeThirdDistPackages(config.THIRD_DIST_PACKAGE),
      };
      this.showBuildConfig = true;
      await this.loadConfigBuildBranches(this.buildConfigForm.CUSTOM_BRANCH || '');
    },
    async loadConfigBuildBranches(keyword = '') {
      this.configBuildBranchLoading = true;
      try {
        const res = await listCustomBranches({
          keyword,
          limit: 50,
        });
        const options = res?.branches || [];
        if (
          this.buildConfigForm.CUSTOM_BRANCH &&
          !options.includes(this.buildConfigForm.CUSTOM_BRANCH)
        ) {
          options.unshift(this.buildConfigForm.CUSTOM_BRANCH);
        }
        this.configBuildBranchOptions = options;
      } catch (error) {
        this.configBuildBranchOptions = this.buildConfigForm.CUSTOM_BRANCH
          ? [this.buildConfigForm.CUSTOM_BRANCH]
          : [];
      } finally {
        this.configBuildBranchLoading = false;
      }
    },
    normalizeThirdDistPackages(value = {}) {
      let packageMap = value || {};
      if (typeof packageMap === 'string') {
        const trimmedValue = packageMap.trim();
        try {
          packageMap = trimmedValue ? JSON.parse(trimmedValue) : {};
        } catch (error) {
          packageMap = trimmedValue ? { default: trimmedValue } : {};
        }
      }
      if (!packageMap || Array.isArray(packageMap) || typeof packageMap !== 'object') {
        packageMap = {};
      }
      const packageNames = Array.from(new Set(['exh', 'icase', ...Object.keys(packageMap)]));
      return packageNames.map((name) => ({
        id: `${name}-${Date.now()}-${Math.random()}`,
        name,
        url: packageMap[name] || '',
        fixed: ['exh', 'icase'].includes(name),
        uploading: false,
        progress: 0,
      }));
    },
    addThirdPackage() {
      this.buildConfigForm.THIRD_DIST_PACKAGES.push({
        id: `package-${Date.now()}-${Math.random()}`,
        name: '',
        url: '',
        fixed: false,
        uploading: false,
        progress: 0,
      });
    },
    deleteThirdPackage(item, index) {
      if (item.fixed) {
        item.url = '';
        item.progress = 0;
        return;
      }
      this.buildConfigForm.THIRD_DIST_PACKAGES.splice(index, 1);
    },
    getThirdDistFileSuffix(fileName = '') {
      const lowerName = fileName.toLowerCase();
      if (lowerName.endsWith('.zip')) return '.zip';
      return '';
    },
    validateThirdDistFile(file) {
      if (!this.getThirdDistFileSuffix(file.name)) {
        this.$message.error('第三方产物包仅支持 .zip');
        return false;
      }
      return true;
    },
    async uploadThirdDistPackage({ file, onSuccess, onError }, item) {
      const suffix = this.getThirdDistFileSuffix(file.name);
      if (!suffix) return;
      item.uploading = true;
      item.progress = 0;
      try {
        const uploadResult = await this.sliceCosObjectWithPrivate(
          {
            fileObject: file,
            suffix,
          },
          this.cos,
          (progressData) => {
            item.progress = Math.floor((progressData.percent || 0) * 100);
          },
          { signal: false },
        );
        item.url = uploadResult?.data || '';
        onSuccess && onSuccess(uploadResult);
        this.$message.success('第三方产物包上传成功');
      } catch (error) {
        console.error('uploadThirdDistPackage error', error);
        onError && onError(error);
        this.$message.error('第三方产物包上传失败');
      } finally {
        item.uploading = false;
      }
    },
    buildThirdDistPackageMap() {
      const packageMap = {};
      for (const item of this.buildConfigForm.THIRD_DIST_PACKAGES) {
        const name = item.name.trim();
        const url = item.url.trim();
        if (!name && !url) continue;
        if (item.fixed && !url) continue;
        if (!name || !url) {
          this.$message.error('第三方产物包名称和私有桶地址需同时填写');
          return null;
        }
        if (!this.getThirdDistFileSuffix(url.split('?')[0])) {
          this.$message.error(`${name} 的产物包地址必须以 .zip 结尾`);
          return null;
        }
        if (!url.includes('private')) {
          this.$message.error(`${name} 的产物包请上传或填写私有桶地址`);
          return null;
        }
        if (packageMap[name]) {
          this.$message.error(`第三方产物包名称重复：${name}`);
          return null;
        }
        packageMap[name] = url;
      }
      return packageMap;
    },
    async saveBuildConfig() {
      const thirdDistPackage = this.tab === 'mp' ? this.buildThirdDistPackageMap() : '';
      if (thirdDistPackage === null) return;

      this.buildConfigSaving = true;
      try {
        const currentConfig = {
          ...(this.kvFullConfig?.[this.tab] || {}),
          CUSTOM_BRANCH: this.buildConfigForm.CUSTOM_BRANCH.trim(),
        };
        if (this.tab === 'mp') {
          currentConfig.BASE_PACKAGE_BRANCH = this.buildConfigForm.BASE_PACKAGE_BRANCH.trim();
          currentConfig.THIRD_DIST_PACKAGE = thirdDistPackage;
        }
        const nextConfig = {
          ...(this.kvFullConfig || {}),
          [this.tab]: currentConfig,
        };
        const data = {
          key: 'front_end_build_config',
          value: formatGqlString(JSON.stringify(nextConfig)),
        };
        if (this.kvInfo.type) data.type = this.kvInfo.type;
        if (this.kvInfo.remark) data.remark = formatGqlString(this.kvInfo.remark);
        await UpdateKvByKey([data]);
        this.showBuildConfig = false;
        this.$message.success('配置保存成功');
        await this.getKvConfig();
      } catch (error) {
        console.error('saveBuildConfig error', error);
        this.$message.error('配置保存失败');
      } finally {
        this.buildConfigSaving = false;
      }
    },
    manage() {
      console.log('manage kvConfig', this.kvConfig.TARGET_APP_ID);
      this.$router.push({
        name: 'mini-verson-detail',
        query: {
          appid: this.kvConfig.TARGET_APP_ID,
          active: 'first',
        },
      });
    },
  },
};
